// extracted by mini-css-extract-plugin
export default {"holder":"PageLayout_holder__Ln9-X"};